import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import en from "./locales/en.json";
import fi from "./locales/fi.json";
import sv from "./locales/sv.json";

// Mirrors the main app's locale settings (apps/web/src/i18n/config.ts):
// same languages, same fallback, and the same localStorage key
// ("i18nextLng") + navigator detection order, so a browser configured for
// the main app resolves to the same language here. Catalogs are bundled
// (labelling-tool pattern) so init is synchronous — components and SSR
// tests never render bare keys.
i18n
	.use(LanguageDetector)
	.use(initReactI18next)
	.init({
		detection: {
			caches: ["localStorage"],
			lookupLocalStorage: "i18nextLng",
			order: ["localStorage", "navigator"],
		},
		fallbackLng: "en",
		interpolation: {
			// React already escapes values
			escapeValue: false,
		},
		resources: {
			en: { translation: en },
			fi: { translation: fi },
			sv: { translation: sv },
		},
	});

export default i18n;
